<template>
  <v-container fluid
               class="fill-height">
    <div class="layout">
      <div class="d-flex flex-grow-1 flex-row mt-2">
        <contacts-sidebar :contacts="contacts">
        </contacts-sidebar>
        <div class="d-flex flex-grow-1 flex-column">
          <router-view :contact="contact"
                       v-if="contact">
          </router-view>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import {find, orderBy} from 'lodash';
import ContactsSidebar from './components/ContactsSidebar';
import nylasService from '../../services/nylasService';

export default {
  components: {ContactsSidebar},
  data() {
    return {
      contacts: [],
      form: new Form({
        limit: 1000,
        offset: 0,
        source: 'address_book',
        page: 1,
        per_page: 5,
      }),
    }
  },
  computed: {
    contactID() {
      return this.$route.params.contactID;
    },
    contact() {
      if (this.contactID) {
        return find(this.contacts, c => c.id === this.contactID);
      }
      return null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const params = {
        limit: this.form.limit,
        offset: this.form.offset,
        source: this.form.source,
      }
      nylasService.getContacts(params)
        .then(data => {
          this.contacts = orderBy(data, ['slug', 'emails.0.email'], ['asc', 'asc']);
        })
    }
  }
}
</script>
